import React from 'react';
import FlexibleTable from '@/stories/Components/FlexibleTable/FlexibleTable';
import { useTranslations } from 'use-intl';
import { toTranslationKey } from '@/utils/translations';
import { HawkAlert } from '@/graphql/__generated__/onboarding';
import { Typography } from '@/UIlibrary/Typography/Typography';
import ExpandableTable from './ExpandableTable';
import { TrialTypeMap, JuryTypeMap } from '@/utils/maps';

interface HawkAlertsDbProps {
	hawkAlertsDb?: (HawkAlert | null)[] | null;
}

const HawkAlertsDb: React.FC<HawkAlertsDbProps> = ({ hawkAlertsDb }) => {
	const t = useTranslations('CreditBureau');
	const tJury = useTranslations('JuryTypes');

	if (!hawkAlertsDb || hawkAlertsDb.length === 0) {
		return (
			<Typography size="sm" color="subtitle">
				{t('NoHawkAlertsDb')}
			</Typography>
		);
	}

	return (
		<ExpandableTable title={t('HawkAlertsDatabase')}>
			<div className="flex flex-col gap-4">
				{hawkAlertsDb.map((alert, index) => {
					if (!alert) return null;

					const translatedData = Object.entries(alert)
						.filter(([key]) => key !== '__typename')
						.reduce(
							(acc, [key, value]) => {
								const translatedKey = t(toTranslationKey(key));
								let translatedValue = value;

								if (key === 'typeOfJury' && value) {
									const mappedJury = JuryTypeMap[value as keyof typeof JuryTypeMap];
									translatedValue = mappedJury ? tJury(toTranslationKey(`${mappedJury}`)) : value;
								} else if (key === 'typeOfTrial' && value) {
									const mappedTrial = TrialTypeMap[value as keyof typeof TrialTypeMap];
									translatedValue = mappedTrial ? tJury(toTranslationKey(`${mappedTrial}`)) : value;
								}

								acc[translatedKey] = translatedValue;
								return acc;
							},
							{} as Record<string, any>
						);

					return (
						<div key={index} className="max-w-4xl">
							<div className="mb-2">
								<Typography size="sm" weight="semibold">
									{t('Alert')} #{index + 1}
								</Typography>
							</div>
							<FlexibleTable flipped data={translatedData} />
						</div>
					);
				})}
			</div>
		</ExpandableTable>
	);
};

export default HawkAlertsDb;
